import { render, staticRenderFns } from "./NolaNovelListItem.vue?vue&type=template&id=2ec2a0cc&scoped=true"
import script from "./NolaNovelListItem.vue?vue&type=script&lang=ts"
export * from "./NolaNovelListItem.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelListItem.vue?vue&type=style&index=0&id=2ec2a0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2a0cc",
  null
  
)

export default component.exports